import appConfig from 'app-config';
import {getImageSrc} from './lobIconUtil';

export function getBrokerUtilLogo(accountPolicyData) {
    if(!(_.isEmpty(accountPolicyData) && accountPolicyData !== null)){

        var brokerImgPathData = {
        "org1": {
           imagePath: "branding/AlDormanInsuranceLogoOrange.png"
         },
         "org2": {
             imagePath: "branding/All-Risks.png"
           },
         "org3": {
            imagePath: "branding/AP_Insurance.png"
          },
          "org4": {
            imagePath: "branding/BickertonGananoque.png"
          },
          "org5": {
            imagePath: "branding/bondy-insurance.png"
          },
          "org6": {
            imagePath: "branding/Cowan.png"
          },
          "org7": {
            imagePath: "branding/DBIbrokersLtdBurns.png"
          },
          "org8": {
            imagePath: "branding/DBIbrokersLtdDalrymple.png"
          },
          "org9": {
            imagePath: "branding/DPMInsurance.png"
          },
          "org10": {
            imagePath: "branding/Duliban.png"
          },
          "org11": {
            imagePath: "branding/Excalibur.png"
          },
          "org12": {
            imagePath: "branding/HaldimandLogo.png"
          },
          "org13": {
            imagePath: "branding/HudsonHenderson.png"
          },
          "org14": {
            imagePath: "branding/HutchesonReynolds.png"
          },
          "org15": {
            imagePath: "branding/ICD.png"
          },
          "org16": {
            imagePath: "branding/Ives.png"
          },
          "org17": {
            imagePath: "branding/JamesHickey.png"
          },
          "org18": {
            imagePath: "branding/HutchesonReynolds.png"
          },
          "org19": {
            imagePath: "branding/Josslin.png"
          },
          "org20": {
            imagePath: "branding/KeyesInsuranceBrokers.png"
          },
          "org21": {
            imagePath: "branding/Mackay.png"
          },
          "org22": {
            imagePath: "branding/mcconville-omni-insurance-brokers.png"
          },
          "org23": {
            imagePath: "branding/McDougall.png"
          },
          "org24": {
            imagePath: "branding/McFarlan.png"
          },
          "org25": {
            imagePath: "branding/McGoey.png"
          },
          "org26": {
            imagePath: "branding/Merit.png"
          },
          "org27": {
            imagePath: "branding/MINK.png"
          },
          "org28": {
            imagePath: "branding/Monarch.png"
          },
          "org29": {
            imagePath: "branding/MorisonBlack.png"
          },
          "org30": {
            imagePath: "branding/Oegema.png"
          },
          "org31": {
            imagePath: "branding/Reith.png"
          },
          "org32": {
            imagePath: "branding/SWB.png"
          },
          "org33": {
            imagePath: "branding/UpperCanada.png"
          },
          "org34": {
            imagePath: "branding/WillIns.png"
          },
          "org35": {
            imagePath: "branding/VanAllen.png"
          },
          "org36": {
            imagePath: "branding/Zehr.png"
          },
          "org37": {
            imagePath: "branding/nfp_logo_green.jpg"
          },
          "org38": {
            imagePath: "branding/RIGL_Final_Logo.jpg"
          },
          "org39": {
            imagePath: "branding/CaldwellRoach_BW.jpg"
          },
          "org40": {
            imagePath: "branding/ML_logo_RGB_black.jpg"
          },
          "org41": {
            imagePath: "branding/CluettLogo.jpg"
          },
          "org42": {
            imagePath: "branding/Fairway.JPG"
          },
          "org43": {
            imagePath: "branding/HuestisLogo.jpg"
          },
         }

         const orgList = {
             'org1' : ['1201'],
             'org2' : ['1751' ,'1754' , '1756' , '1757' , '1758' , '1759' ,
                        '1762' , '1763' , '1764' , '1765' , '1766' , '1767' , '1768' , '1769' ,
                        '1770' , '1771', '1772' , '1773' , '1774' , '1775' , '1776' , '1777' ,
                        '1778' , '1779', '1781'],
             'org3' : ['2751'],
             'org4' : ['2116'],
             'org5' : ['5901'],
             'org6' : ['7301'],
             'org7' : ['7902'],
             'org8' : ['7901'],
             'org9' : ['4151' , '4152' , '4153' , '4154' , '4155'],
             'org10' : ['1101' , '1102' , '1103' , '1104' , '1105'],
             'org11' : ['2604' , '2606' , '2607'],
             'org12' : ['8001'],
             'org13' : ['1651' , '1652' , '1654' , '1655'],
             'org14' : ['1051'],
             'org15' : ['1151'],
             'org16' : ['8951'],
             'org17' : ['2115'],
             'org18' : ['6551' , '6552', '6553','6554' , '4001'],
             'org19' : ['5102' , '5103', '5104'],
             'org20' : ['6301'],
             'org21' : ['3651'],
             'org22' : ['8411' , '8412', '8413'],
             'org23' : ['2101' , '2112' , '2113' , '2117' , '4402'],
             'org24' : ['101' , '103' , '104' , '105' , '106' , '108' , '110' ,
                        '111' , '112' , '113' , '114' , '115' , '117' , '118' , '123' ,
                        '124' , '125' , '127' , '3601'],
             'org25' : ['401'],
             'org26' : ['1851'],
             'org27' : ['2701'],
             'org28' : ['9950'],
             'org29' : ['7501' , '7502' , '1601' , '1801' , '1802' , '9916' , '9918'],
             'org30' : ['5701' , '5702' , '5703' , '5704' , '5705'],
             'org31' : ['7001'],
             'org32' : ['2501'],
             'org33' : ['5251'],
             'org34' : ['4801'],
             'org35' : ['6901' , '6902' , '2851'],
             'org36' : ['901' , '902' , '903' , '904' , '908' , '909',
                         '910' , '911' , '912'],
             'org37' : ['201' , '209' , '210' , '4901' , '4902' , '7801'],
             'org38' : ['NS082' , 'NS102' , 'NS116'],
             'org39' : ['NS108' , 'NS114' , 'NS150' , 'NS156' , 'NS170' , 'NS171'],
             'org40' : ['NS113' , 'NS127' , 'NS129' , 'NS130' , 'NS131' , 'NS142' , 'NS154' , 'NS155'],
             'org41' : ['NS100'],
             'org42' : ['NS119' , 'NS151'],
             'org43' : ['NS128' , 'NS133' , 'NS134' , 'NS136'],
         }
         var producerCode = accountPolicyData[0].producerContact.producerCode_EY;
         const getDataByProducerCode = (producerCode) => {
           var orgNames = Object.keys(orgList);
           //  console.log(orgNames)
           return _.filter(orgNames, (orgName) => {
            //console.log(orgList[orgName]);
            return orgList[orgName].indexOf(producerCode) != -1
          })
         }
        
         const srcPath = brokerImgPathData[getDataByProducerCode(producerCode)] ? brokerImgPathData[getDataByProducerCode(producerCode)].imagePath : undefined;
         if(!(_.isUndefined(srcPath))){
            return getImageSrc(srcPath);
         }else{
            return false;
            }
        }
}


